import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  Box,
  HStack,
  Checkbox } from
"@chakra-ui/react";
import React, { useEffect, useState } from "react";
import styles from "../../../styles/feedback.module.css";
import Assistant from "../../molecules/ai-tutor/Assistant/Assistant";
import Dropdown from "./Dropdown";
import CustomButton from "../../atoms/CustomButton/CustomButton";
import SendImg from "../../../assets/ai-tutor/send.svg";
import {
  feedback_initialstate,
  FeedbackVin } from
"../../../utils/TutorConstants";
import {
  fetchFeedbackDropdowns,
  saveFeedback } from
"../../../network/TutorApiService";
import { isEmptyOrNull } from "../../../utils/common-utils";
import { useTutor } from "../../../context/AiTutorContext";
import useStateRef from "react-usestateref";
import { useRoot } from "../../../context/RootContext";

export default function FeedbackModal(props) {
  const { isStandalone } = useRoot();
  const { chatId, mode, setIsFeedbackSubmitted, curriculumObj } = props;
  const { openFeedbackModal, setOpenFeedbackModal } = useTutor();
  const [feedbackOptions, setFeedbackOptions, feedbackOptionsRef] = useStateRef(
    feedback_initialstate
  );
  const [feedbackDropdowns, setFeedbackDropdowns, feedbackDropdownsRef] =
  useStateRef([]);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    fetchDropdownList();
  }, []);

  const fetchDropdownList = async () => {
    let response = await fetchFeedbackDropdowns(mode);
    setFeedbackDropdowns(response);
  };
  const handleChange = (key, value) => {
    let existing = { ...(feedbackOptions || {}) };
    existing[key] = value;
    if (key == "outcome") {
      existing.outcome_reason = "";
      if (mode == "Doubt") {
        //In doubt, by default division is "Ai Tutor related"
        existing.outcome_division = "Ai Tutor related";
      } else {
        existing.outcome_division = "";
      }
    } else if (key == "conversation_flow") {
      existing.conversation_reason = "";
    }
    setFeedbackOptions(existing);
  };
  const handleSaveFeedback = async () => {
    let response = await saveFeedback(
      chatId,
      feedbackOptions,
      mode,
      curriculumObj
    );
    setIsSubmitted(true);
    setIsFeedbackSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
      setOpenFeedbackModal(false);
    }, 2000);
  };
  const {
    outcome = "",
    outcome_division = "",
    outcome_reason = "",
    conversation_flow = "",
    conversation_reason = "",
    comment,
    show_to_student = false
  } = feedbackOptionsRef?.current;

  const Outcome = feedbackDropdownsRef?.current?.[0]?.outcome;
  const ConvFlow = feedbackDropdownsRef?.current?.[0]?.conversation_flow;
  const OutcomeDivisions = Outcome?.divisions || [];
  const OutcomeReasons = Outcome?.reasons.not_satisfactory || {};
  const ConvFlowReasons = ConvFlow?.reasons.not_satisfactory || [];
  const isOutcomeSatisfactory = outcome == "Satisfactory";
  const isConvFlowSatisfactory = conversation_flow == "Satisfactory";

  let isEnable = !isEmptyOrNull(outcome) && !isEmptyOrNull(conversation_flow);
  if (outcome != "Satisfactory") {
    isEnable =
    isEnable &&
    !isEmptyOrNull(outcome_division) &&
    !isEmptyOrNull(outcome_reason);
  }
  if (conversation_flow != "Satisfactory") {
    isEnable = isEnable && !isEmptyOrNull(conversation_reason);
  }
  const doubtWidth = mode == "Practice" ? "60%" : "50%";
  const PracWidth = mode == "Practice" ? "40%" : "50%";

  return (
    <Drawer
      placement={"bottom"}
      onClose={() => {
        setOpenFeedbackModal(false);
      }}
      isOpen={openFeedbackModal}
      bgColor={"#ff"}>

      <DrawerOverlay />
      <DrawerContent sx={{ bgColor: "#fff" }} className={styles["container"]}>
        <Assistant text={FeedbackVin} />
        {isStandalone &&
        <Box ml={"52px"} mt={"-10px"}>
            <Checkbox
            isChecked={show_to_student}
            onChange={(e) => {
              handleChange("show_to_student", e.target.checked);
            }}>

              <div className={styles["feedback-text"]}>
                Share this question to student
              </div>
            </Checkbox>
          </Box>
        }
        <div className={styles["dropdown-container"]}>
          <HStack
            w={["100%", doubtWidth]}
            pr={[0, 4]}
            pb={[4, 0]}
            borderRightWidth={[0, 2]}
            borderBottomWidth={[2, 0]}
            borderColor={"gray.600"}
            flexDirection={["column", "row"]}>

            <Dropdown
              placeholder={"Outcome"}
              data={Outcome?.options || []}
              value={outcome}
              setValue={(value) => {
                handleChange("outcome", value);
              }} />

            {mode == "Practice" &&
            <Dropdown
              placeholder={"Division"}
              data={isOutcomeSatisfactory ? [] : OutcomeDivisions}
              value={outcome_division}
              setValue={(value) => {
                handleChange("outcome_division", value);
              }}
              isDisable={isOutcomeSatisfactory || outcome == ""} />

            }
            <Dropdown
              placeholder={"Reason"}
              data={OutcomeReasons?.[outcome_division]}
              value={outcome_reason}
              setValue={(value) => {
                handleChange("outcome_reason", value);
              }}
              isDisable={isOutcomeSatisfactory || outcome_division == ""} />

          </HStack>
          <HStack w={["100%", PracWidth]} flexDirection={["column", "row"]}>
            <Dropdown
              placeholder={"Conversation"}
              data={ConvFlow?.options || []}
              value={conversation_flow}
              setValue={(value) => {
                handleChange("conversation_flow", value);
              }} />

            <Dropdown
              placeholder={"Reason"}
              data={isConvFlowSatisfactory ? [] : ConvFlowReasons}
              value={conversation_reason}
              setValue={(value) => {
                handleChange("conversation_reason", value);
              }}
              isDisable={isConvFlowSatisfactory || conversation_flow == ""} />

          </HStack>
        </div>
        <div className={styles["comment-container"]}>
          <div className={styles["label"]}>Comment</div>
          <textarea
            className={styles["text-area"]}
            value={comment}
            onChange={(e) => {
              handleChange("comment", e.target.value);
            }} />

        </div>
        <div className={styles["button-container"]}>
          {isSubmitted ?
          <div className={styles["feedback-text"]}>Feedback recorded</div> :

          <div />
          }
          <CustomButton
            label={`Send`}
            image={SendImg}
            isDisabled={!isEnable}
            handleClick={() => {
              isEnable && handleSaveFeedback();
            }} />

        </div>
      </DrawerContent>
    </Drawer>);

}